import _ from 'underscore';
import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { likeSpeakerToggle, fetchSpeakerData } from '../../../../actions/SpeakerActions';
import {
    showEmailLogin,
    hideEmailLogin,
    setLoginV2OffsetTop,
} from '../../../../actions/LoginActions';
import SpeakerView from './SpeakerView';
import {
    speakerSelector,
    sessionsSelector,
    shouldFetchSpeakerSelector
} from '../../../../selectors/SpeakerSelectors';
import { eventUrlsSelector } from '../../../../selectors/EventSelectors';
import {
    eventSelector, getInternalAgendaUrl
} from '../../../../selectors/EventSelectors';
import { siteConfSelector } from '../../../../selectors/SiteConfSelectors';
import { settingsSelector } from '../../../../selectors/AgendaSelectors';
import { isLoginShownSelector } from '../../../../selectors/LoginSelectors';


const SpeakerViewContainer = props => {
    const goToPreviousPage = () => {
        const { agendaUrl } = props;
        if (!document.referrer){
            return browserHistory.push(agendaUrl);
        }
        return browserHistory.goBack();
    };
    return <SpeakerView {...props} goBack={goToPreviousPage} />;
};


const mapStateToProps = (state, ownProps) => {
    // eslint-disable-next-line no-unused-vars
    const { routeParams: { id: speakerId }, location: { query: { widget: hasWidgetParam }} } = ownProps;
    const siteConf = siteConfSelector(state);
    const isWidget = !!(siteConf.isWidget);
    const event = eventSelector(state);
    const settings = settingsSelector(state);

    return {
        event,
        eventId: event.id,
        speaker: speakerSelector(state, { speakerId }),
        shouldFetchSpeaker: shouldFetchSpeakerSelector(state, { speakerId }),
        sessions: sessionsSelector(state),
        isWidget,
        agendaUrl: getInternalAgendaUrl(state),
        eventUrls: eventUrlsSelector(state),
        isEmailLoginShown: isLoginShownSelector(state),
        speakerId,
        siteConf,
        settings,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { routeParams: { id: speakerId } } = ownProps;
    return bindActionCreators({
        likeSpeakerToggle,
        fetchSpeakerData: _.partial(fetchSpeakerData, speakerId),
        showEmailLogin,
        hideEmailLogin,
        setLoginV2OffsetTop,
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(SpeakerViewContainer);
